module.exports = __webpack_public_path__ + "img/title.e0eba067.png";